// Generated by Melange

import * as Fx from "../fx/fx.jsx";
import * as StoreFx__FetchOneAlbum from "./fetchOneAlbum.jsx";
import * as StoreFx__FetchOneArtist from "./fetchOneArtist.jsx";
import * as StoreFx__FetchOneSong from "./fetchOneSong.jsx";
import * as Subsonic__Star from "../api/subsonic/star.jsx";

function make(params) {
  return Fx.Monad_syntax.let$star(Fx.ask(undefined), (function (param) {
    const state = param.store.getState();
    return Fx.Monad_syntax.let$star(Fx.provide(Subsonic__Star.make(params), {
      credentials: state.auth.credentials
    }), (function (param) {
      const albumId = params.albumId;
      if (albumId !== undefined) {
        return StoreFx__FetchOneAlbum.make(albumId);
      }
      if (params.artistId === undefined && params.id === undefined) {
        return {
          TAG: /* Ok */ 0,
          _0: undefined
        };
      }
      const artistId = params.artistId;
      if (artistId !== undefined) {
        return StoreFx__FetchOneArtist.make(artistId);
      } else {
        return StoreFx__FetchOneSong.make(params.id);
      }
    }));
  }));
}

export {
  make,
}
/* StoreFx__FetchOneAlbum Not a pure module */
